import { render, staticRenderFns } from "./AgeConfirmation.vue?vue&type=template&id=eff0a7a0&scoped=true&"
import script from "./AgeConfirmation.vue?vue&type=script&lang=js&"
export * from "./AgeConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AgeConfirmation.vue?vue&type=style&index=0&id=eff0a7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff0a7a0",
  null
  
)

export default component.exports